import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useRenewLoanApplicationDependency() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: ({
      applicationID,
      dependencyID,
    }: {
      applicationID: string;
      dependencyID: string;
    }) =>
      loan_application_api.renewLoanApplicationDependency(api)(
        applicationID,
        dependencyID
      ),

    onSettled: (_data, _error, variables) => {
      client.invalidateQueries(
        applicationKeys.dependencies(variables.applicationID)
      );
    },
  });
}
